var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "safari-pinned-tab.325eeb1b.svg",
    width: 800,
    height: 800
});